import { Roles } from '@client/graphql/__generated__/types';
import { Navigate, Outlet } from 'react-router-dom';
import { NotSupportedMarketWithMainLayout } from '~/apps/consumer/components/ProductFeatures/NotSupportedMarket';
import { useSignUpOnboarding } from '~/apps/consumer/hooks/useSignUpOnboarding';
import { SwitchUser } from '~/common/components/SwitchUser/SwitchUser';
import { GlobalHooks } from '~/common/copilot/GlobalHooks';
import { useAppContext } from '../../contexts/AppContext';

export const Authenticated = () => {
  const { isAuthenticated, user, supportedFeatures } = useAppContext();
  const { isOnboardingCompleted, isOnboardingStarted } = useSignUpOnboarding();

  if (!isAuthenticated) {
    return (
      <Navigate
        replace
        to={{
          pathname: '/auth/login',
          search: `?next=${window.location.pathname}`,
        }}
      />
    );
  }

  if (
    (user?.licenses && user?.licenses.length === 0) ||
    (isOnboardingStarted() && !isOnboardingCompleted())
  ) {
    return <Navigate to="/auth/signup" />;
  }

  if (supportedFeatures.length === 0) {
    return <NotSupportedMarketWithMainLayout />;
  }

  return (
    <>
      <Outlet />
      <GlobalHooks />
      {window.ENVS.environment !== 'production' &&
        (user?.roles.includes(Roles.ADMIN) || !!window.ENVS.switchedUser) && (
          <SwitchUser />
        )}
    </>
  );
};
